import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../wrapper";
import { logInUserInfo } from "../../Actions/Users";
import { WorkshopsList } from "../../Components/WorkShops/index";
import axios from "axios";
import withRoutes from "../../HOC/HocRoutes";
import instance from "../../axios";
import { errorHandler } from "../../Helpers";
import {
  parseWorkingHours,
  serializeWorkingHours,
  getDefaultWorkingHoursObject,
} from "../../Components/WorkShops/addWorkShops";
const defaultAttributes = {
  vehicleTypes: "",
  makers: "",
  serviceTypes: "",
  amennities: "",
  workinghours: getDefaultWorkingHoursObject(),
};
const DEFAULT_WORKSHOP_STATUS = {
  key: "Active",
  name: "Active",
};
const formDefault = {
  id: "",
  name: "",
  description: "",
  garageNumber: "",
  garageArea: "",
  garageManager: "",
  email: "",
  phone: "",
  address: "",
  garageType: "Default",
  latitude: "",
  longitude: "",
  multiplier: "",
  status: DEFAULT_WORKSHOP_STATUS,
  attributes: {
    ...defaultAttributes,
  },
};

const toFieldValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return value;
  }
  if (typeof value === "object") {
    return value.key || value.name || value.id || "";
  }
  return value;
};

const toCityId = (value) => {
  if (value === null || value === undefined || value === "") {
    return value;
  }
  if (typeof value === "object") {
    return value.id ?? "";
  }
  return value;
};

const makeGrageData = (data) => {
  const payload = {
    ...data,
    garageType: toFieldValue(data.garageType),
    garageCity: toCityId(data.garageCity),
    sla: toFieldValue(data.sla),
    status: toFieldValue(data.status) || "Active",
    affiliation: toFieldValue(data.affiliation),
    attributes: { ...(data.attributes || {}) },
  };
  delete payload.workingHours;
  delete payload.workinghours;
  return payload;
};

let source;
class Workshops extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: {},
      userFetch: false,
      addOption: false,
      editOption: false,
      garagesData: "",
      form: { ...formDefault },
      isVisableAddBtn: false,
      selectedWorkShop: "",
      onDeleteConfirmation: false,
      page: 1,
      pageSize: 20,
      searchGarage: "",
      loader1: false,
      garageCity: "",
      garageType: "",
      workshopStatus: "",
      selectedWorkshopStatus: "",
      categoriesList: [],
      isVisableFilterBtn: false,
      enableReset: false,
      allMakes: [],
      makesLoading: false,
    };
    this.makesPagination = {
      page: 1,
      search: "",
      hasNext: false,
      loading: false,
    };
    this.makesSearchTimer = null;
    this.getWorkshops = this.getWorkshops.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.workShopSelection = this.workShopSelection.bind(this);
    this.updateWorkshops = this.updateWorkshops.bind(this);
    this.deleteWorkShop = this.deleteWorkShop.bind(this);
    this.removeEnable = this.removeEnable.bind(this);
  }
  fetchCategories = () => {
    fetch(`/api/vehiclecategorys/get?page=1&limit=500&category=`)
      .then((response) => {
        if (response.ok) {
          response.json().then((res) => {
            if (res.status === "success") {
              const raw = res.data?.data ?? res.data ?? [];
              const list = Array.isArray(raw) ? raw : [];
              const categoriesList = list
                .map((item) => {
                  const name =
                    typeof item === "string" ? item : item?.categoryName;
                  if (!name) return null;
                  return { id: name, label: name, value: name };
                })
                .filter(Boolean);
              this.setState({ categoriesList });
            } else if (res?.statusCode === "440") {
              window.location.replace("/login");
            } else if (res.statusCode) {
              var err = res?.message.split(":");
              err[1] = err[1].replace(")", "");
              toast.error(this.props.translate(err[1]));
            }
          });
        }
      })
      .catch((e) => {
        console.log("e =", e);
      });
  };
  mapMakeToOption = (item) => ({
    id: item.id,
    key: item.makeName,
    label: item.makeName,
    value: item.makeName,
  });

  fetchMakesPage = async (page = 1, search = "") => {
    const data = await instance({
      method: "GET",
      url: `/api/makes/get?page=${page}&limit=20&make=${encodeURIComponent(search)}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const list = Array.isArray(data?.data) ? data.data : [];
    const total = parseInt(data?.total, 10) || 0;
    const hasNext = Boolean(data?.hasNext ?? total > page * 20);
    return {
      options: list.map(this.mapMakeToOption),
      hasNext,
    };
  };

  fetchMake = async () => {
    try {
      this.setState({ makesLoading: true });
      const { options, hasNext } = await this.fetchMakesPage(1, "");
      this.makesPagination = { page: 1, search: "", hasNext, loading: false };
      this.setState({ allMakes: options, makesLoading: false });
    } catch (error) {
      errorHandler(error, this.props.dispatch);
      this.setState({ allMakes: [], makesLoading: false });
    }
  };

  searchMakesList = (search = "") => {
    if (this.makesSearchTimer) {
      clearTimeout(this.makesSearchTimer);
    }
    this.makesSearchTimer = setTimeout(async () => {
      try {
        this.setState({ makesLoading: true });
        const { options, hasNext } = await this.fetchMakesPage(1, search);
        this.makesPagination = { page: 1, search, hasNext, loading: false };
        this.setState({ allMakes: options, makesLoading: false });
      } catch (error) {
        errorHandler(error, this.props.dispatch);
        this.setState({ allMakes: [], makesLoading: false });
      }
    }, 300);
  };

  loadMoreMakes = async () => {
    const pag = this.makesPagination || {};
    if (!pag.hasNext || pag.loading) return;

    this.makesPagination.loading = true;
    this.setState({ makesLoading: true });

    try {
      const nextPage = pag.page + 1;
      const { options, hasNext } = await this.fetchMakesPage(
        nextPage,
        pag.search,
      );
      const merged = [...(this.state.allMakes || []), ...options];
      this.makesPagination = {
        page: nextPage,
        search: pag.search,
        hasNext,
        loading: false,
      };
      this.setState({ allMakes: merged, makesLoading: false });
    } catch (error) {
      this.makesPagination.loading = false;
      this.setState({ makesLoading: false });
      errorHandler(error, this.props.dispatch);
    }
  };
  modalControle = () => {
    this.setState({
      addOption: false,
      editOption: false,
      form: "",
    });
  };

  addGarages = () => {
    this.fetchCategories();
    this.fetchMake();
    this.setState(
      {
        addOption: true,
        form: {
          ...formDefault,
          attributes: { ...defaultAttributes },
        },
      },
      () => this.checkRequiredFields(),
    );
  };
  parseCommaToSelect = (value) => {
    if (typeof value !== "string" || !value.trim()) return [];

    return value
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean)
      .map((v) => ({
        value: v,
        label: v,
      }));
  };
  handleChange1 = (name, event) => {
    if (name === "status" && !event) {
      return;
    }
    // if(name==="garageType"){
    this.setState(
      {
        form: {
          ...this.state.form,
          [name]: event,
        },
      },
      () => this.checkRequiredFields(),
    );
  };
  handleChange = (name) => (event) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [name]: event.target.value,
        },
      },
      () => this.checkRequiredFields(),
    );
  };

  checkRequiredFields() {
    let { name, garageType, garageNumber, status } = this.state.form;
    const statusValue = status?.name || status?.key || status;

    if (name && garageType && garageNumber && statusValue) {
      this.setState({
        isVisableAddBtn: true,
      });
    } else {
      this.setState({
        isVisableAddBtn: false,
      });
    }
  }

  handleChangeDropdowns = (name, event) => {
    this.setState(
      (prevState) => {
        const form = { ...prevState.form };

        if (name === "status") {
          form.status = event || "";
        } else {
          form.attributes = {
            ...(form.attributes || {}),
            [name]: event || "",
          };
        }

        return { form };
      },
      () => {
        this.checkRequiredFields();
      },
    );
  };

  toCommaString = (value) => {
    if (!value) return "";

    if (typeof value === "string") {
      return value.trim();
    }

    if (Array.isArray(value)) {
      return value
        .map((v) => {
          if (typeof v === "object") {
            return v.value || v.label || v.id;
          }
          return v;
        })
        .filter(Boolean)
        .join(",");
    }

    return String(value);
  };
  handleSubmit = async () => {
    let { form } = this.state;
    const obj = makeGrageData(form);
    const mapping = {
      amennities: "attributes",
      makers: "attributes",
      vehicleTypes: "attributes",
      serviceTypes: "attributes",
    };

    obj.attributes = obj.attributes || {};

    Object.entries(mapping).forEach(([key, target]) => {
      if (target === "root") {
        obj[key] = this.toCommaString(obj[key]);
      } else {
        const value = obj.attributes?.[key];

        obj.attributes[key] = this.toCommaString(value);
      }
    });
    let result;

    this.setState(
      {
        addOption: false,
        editOption: false,
        isVisableAddBtn: false,
      },
      async () => {
        result = await axios.post(`/api/garages`, obj);
        if (result.data.status === "success") {
          this.setState({
            searchGarage: "",
            // editOption: false,
            form: "",
          });

          toast.success(this.props.translate("workShopAdded"));
          this.getWorkshops();
        } else {
          this.setState(
            {
              searchGarage: "",
              // editOption: false,
              form: "",
            },
            this.getWorkshops(),
          );

          toast.error(this.props.translate(result.data.message));
        }
      },
    );
  };

  checkSearchFields() {
    let { garageCity, garageType, workshopStatus } = this.state;

    if (garageCity || garageType || workshopStatus) {
      this.setState({
        isVisableFilterBtn: true,
      });
    } else {
      this.setState({
        isVisableFilterBtn: false,
      });
    }
  }

  searchContractText = (e, name) => {
    source.cancel();
    if (name === "garageType") {
      this.setState({ [name]: e.target.value }, () => {
        this.checkSearchFields();
      });
    } else if (e === "garageCity") {
      this.setState({ [e]: name.id, selectedGarageCity: name }, () => {
        this.checkSearchFields();
      });
    } else if (e === "status") {
      this.setState(
        {
          workshopStatus: name?.id || name?.key || "",
          selectedWorkshopStatus: name || "",
          page: 1,
        },
        () => {
          this.checkSearchFields();
        },
      );
    } else {
      this.setState(
        {
          searchGarage: e.target.value,
        },
        () => {
          this.getWorkshops();
        },
      );
    }
  };

  getWorkshops = () => {
    let { page, pageSize, searchGarage, garageCity, garageType, workshopStatus } =
      this.state;
    const params = new URLSearchParams({
      userId: this.props.logInUser?.id,
      page,
      limit: pageSize,
      all: true,
      search: searchGarage,
      ...(garageCity && { garageCity }),
      ...(garageType && { garageType }),
      ...(workshopStatus && { status: workshopStatus }),
    });
    let apiUrl = `/api/garages/get?${params.toString()}`;

    source = axios.CancelToken.source();
    this.setState(
      {
        loader1: true,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            this.setState({
              loader1: false,
              enableReset: this.state.isVisableFilterBtn ? true : false,
              garagesData: response?.data.data || [],
            });
          })
          .catch((e) => {
            // console.log("e ===", e);
          });
      },
    );
  };

  // getWorkshopCities = () => {
  //   let apiUrl = `/api/citys/get?limit=-1`;
  //   this.setState(
  //     {
  //       loader2: true,
  //     },
  //     () => {
  //       axios
  //         .get(apiUrl)
  //         .then((response) => {
  //           const updatedResponse=response?.data?.data?.data?.map((item)=>({
  //             ...item,
  //             name:item?.cityEn||item?.label
  //           }))
  //           this.setState({
  //             loader2: false,
  //             garageCities: updatedResponse || [],
  //           });
  //         })
  //         .catch((e) => {
  //           // console.log("e ===", e);
  //         });
  //     }
  //   );
  // };

  componentDidMount() {
    this.getWorkshops();
    // this.getWorkshopCities()
  }

  applyWorkshopForm = (item) => {
    if (!item) return;

    const selectedCity =
      typeof item.garageCity === "object"
        ? item.garageCity
        : this.props.cities?.find((city) => city.id == item.garageCity) || null;

    const workinghours = serializeWorkingHours(
      parseWorkingHours(
        item.attributes?.workinghours || item.attributes?.workingHours,
      ),
    );

    const updatedItem = {
      ...item,
      garageCity: selectedCity,
      attributes: {
        ...item.attributes,
        makers: item.attributes?.makers
          ? this.parseCommaToSelect(item.attributes.makers)
          : "",
        vehicleTypes: item.attributes?.vehicleTypes
          ? this.parseCommaToSelect(item.attributes.vehicleTypes)
          : "",
        serviceTypes: item.attributes?.serviceTypes
          ? this.parseCommaToSelect(item.attributes.serviceTypes)
          : "",
        amennities: item.attributes?.amennities
          ? this.parseCommaToSelect(item.attributes.amennities)
          : "",
        workinghours,
      },
    };

    this.setState(
      {
        selectedWorkShop: updatedItem,
        editOption: true,
        form: {
          ...updatedItem,
          garageType: updatedItem.garageType,
          status: updatedItem.status || DEFAULT_WORKSHOP_STATUS,
        },
      },
      () => this.checkRequiredFields(),
    );
  };

  workShopSelection = (items) => {
    this.fetchCategories();
    this.fetchMake();
    const item = items;
    if (!item) return;

    const garageId = item.id;
    if (!garageId) {
      this.applyWorkshopForm(item);
      return;
    }

    instance
      .get(`/api/garages/${garageId}`)
      .then((res) => {
        const detail =
          res && typeof res === "object" && !Array.isArray(res) ? res : {};
        this.applyWorkshopForm({
          ...item,
          ...detail,
          attributes: {
            ...(item.attributes || {}),
            ...(detail.attributes || {}),
          },
        });
      })
      .catch(() => {
        this.applyWorkshopForm(item);
      });
  };

  updateWorkshops = async () => {
    const { selectedWorkShop, form } = this.state;
    // const obj = { ...form };
    const obj = makeGrageData(form);
    const mapping = {
      // status: 'root',
      amennities: "attributes",
      makers: "attributes",
      vehicleTypes: "attributes",
      serviceTypes: "attributes",
    };

    obj.attributes = obj.attributes || {};

    Object.entries(mapping).forEach(([key, target]) => {
      if (target === "root") {
        obj[key] = this.toCommaString(obj[key]);
      } else {
        const value = obj.attributes?.[key];

        obj.attributes[key] = this.toCommaString(value);
      }
    });

    let result = await axios.put(`/api/garages/${selectedWorkShop.id}`, obj);
    if (result.data.status === "success") {
      this.setState({
        addOption: false,
        editOption: false,
        isVisableAddBtn: false,
      });

      toast.success(this.props.translate("WorkShop Updated"));
      this.getWorkshops();
    } else {
      toast.error(this.props.translate(result.data.message));
    }
  };

  deleteWorkShop = async () => {
    const { selectedWorkShop } = this.state;
    let result = await axios.delete(`/api/garages/${selectedWorkShop.id}`);

    if (result.data.status === "success") {
      // this.getFilteredPAyments(this.state.to,this.state.from,this.state.account,this.state.vehcile,this.state.area)

      toast.success(this.props.translate("Workshop Deleted"));
      this.setState(
        {
          onDeleteConfirmation: false,
          searchGarage: "",
        },
        () => this.getWorkshops(),
      );
    } else {
      toast.error(this.props.translate(result.data.message));
    }
  };

  removeEnable = async (selected) => {
    if (selected[0]) {
      await this.setState({
        selectedWorkShop: selected[0],
        onDeleteConfirmation: true,
        form: "",
      });
    } else {
      this.setState({
        onDeleteConfirmation: true,
        form: "",
      });
    }
  };
  onCancel = () => {
    this.setState({
      onDeleteConfirmation: false,
    });
  };

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  setPagination = (items) => {
    let nItem = { ...items };
    let lastPage = nItem.total / this.state.pageSize;
    let IsFloate = this.checkFloteNumber(lastPage);
    delete nItem.data;
    nItem.pageSize = this.state.pageSize;
    nItem.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
    return nItem;
  };

  //   getFilteredPAyments
  // getPaymentList
  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ page: 1, pageSize: rowsPerPage }, () => {
      this.getWorkshops();
    });
  };

  handleChangePage = (value) => {
    this.setState({ page: value }, () => {
      this.getWorkshops();
    });
  };

  getGarages = () => {
    this.setState({ enableReset: true }, () => {
      this.getWorkshops();
      this.checkSearchFields();
    });
  };

  resetGarages = () => {
    this.setState(
      {
        garageCity: "",
        garageType: "",
        selectedGarageCity: "",
        workshopStatus: "",
        selectedWorkshopStatus: "",
        isVisableFilterBtn: false,
      },
      () => {
        this.getWorkshops();
      },
    );
  };

  getPostion = (latlng, zoom) => {
    if (latlng.lat && latlng.lng && zoom) {
      this.setState({
        localPostionObj: { latlng, zoom },
        isVisableAddlocBtn: true,
      });
    }
  };
  onCloseModal = () => {
    this.setState({
      isMapModal: false,
    });
  };
  setSelectedLocation = () => {
    const { localPostionObj } = this.state;
    if (localPostionObj) {
      this.setState(
        {
          form: {
            ...this.state.form,
            latitude: localPostionObj.latlng.lat,
            longitude: localPostionObj.latlng.lng,
            zoom: localPostionObj.zoom,
          },
          isMapModal: false,
        },
        () => this.checkRequiredFields(),
      );
    }
  };
  handleClickShowPostion = () => {
    this.setState({
      isMapModal: true,
      isVisableAddlocBtn: false,
    });
  };
  render() {
    if (this.props.logInUser) {
      return (
        <Layout {...this.props} noSidebar>
          {/* Workshops */}
          <WorkshopsList
            {...this.props}
            {...this.state}
            getGarages={this.getGarages}
            resetGarages={this.resetGarages}
            searchContractText={this.searchContractText}
            addOption={this.state.addOption}
            modalControle={this.modalControle}
            addGarages={this.addGarages}
            garagesData={this.state.garagesData}
            data={this.state.form}
            handleChangeDropdowns={this.handleChangeDropdowns}
            allMakes={this.state.allMakes}
            makesLoading={this.state.makesLoading}
            searchMakesList={this.searchMakesList}
            loadMoreMakes={this.loadMoreMakes}
            categoriesList={this.state.categoriesList}
            fetchCategories={this.fetchCategories}
            handleChange={this.handleChange}
            handleChange1={this.handleChange1}
            isVisableAddBtn={this.state.isVisableAddBtn}
            checkRequiredFields={this.checkRequiredFields}
            handleSubmit={this.handleSubmit}
            editOption={this.state.editOption}
            workShopSelection={this.workShopSelection}
            selectedWorkShop={this.state.selectedWorkShop}
            updateWorkshops={this.updateWorkshops}
            deleteWorkShop={this.deleteWorkShop}
            removeEnable={this.removeEnable}
            onCancel={this.onCancel}
            setPagination={this.setPagination}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleClickShowPostion={this.handleClickShowPostion}
            getPostion={this.getPostion}
            onCloseModal={this.onCloseModal}
            setSelectedLocation={this.setSelectedLocation}
          />
        </Layout>
      );
    } else {
      fetch(
        "/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05",
        {
          headers: { Accept: "application/json; odata=verbose" },
        },
      )
        .then((response) => {
          if (response.ok) {
            response.json().then((res) => {
              if (res.status === "success") {
                let userInfo = res.data;
                this.props.setActiveLanguage(
                  userInfo?.attributes?.lang || "en",
                );
                this.props.dispatch(logInUserInfo(userInfo));
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                var err = res?.message.split(":");
                err[1] = err[1].replace(")", "");

                toast.error(this.props.translate(err[1]));
                this.props.navigate("/login");
              }
            });
          } else {
            this.props.navigate("/login");
            throw response;
          }
        })
        .catch((e) => {
          toast.error("somethingWentWrong");
        });
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
  cities: state.Cities.cities,
});

export default connect(mapStateToProps)(withRoutes(Workshops));
